/**
 * Sección sin construir.
 *
 * Se dice con todas las letras en lugar de enseñar una tabla vacía o un
 * «próximamente». Una pantalla que parece funcionar y no funciona hace
 * perder más tiempo que una que avisa: quien la abra sabrá que el dato no
 * falta, es que la pantalla no está.
 */

interface Props {
  title: string;
  group: string;
}

export function PendingScreen({ title, group }: Props): React.ReactNode {
  return (
    <section className="pending">
      <h1 className="pending__title">{title}</h1>
      <p className="pending__note">
        {group ? `Sección de ${group.toLowerCase()} pendiente de construir.` : 'Esta ruta no existe.'}{' '}
        Los datos y la API que hay detrás sí están: falta la pantalla.
      </p>
    </section>
  );
}
